export default "__VITE_ASSET__BtLdce47__"